import { CreativeLibraryPanel, PanelIntent, PanelView } from 'modules/creativeLibrary';
import { useModalContext } from 'utils/contexts/modal';
import { useWYSIWYGContext } from '../../contexts/WYSIWYGContext';
import { useHandleImageInsert } from '../../hooks';

export const CreativeLibraryPanelModal = () => {
  const { selectedImage } = useWYSIWYGContext();
  const { hideModal } = useModalContext();
  const initView = selectedImage ? PanelView.Detail : PanelView.List;
  const intent = selectedImage ? PanelIntent.Edit : PanelIntent.Insert;
  const handleImageInsert = useHandleImageInsert();

  return (
    <CreativeLibraryPanel
      initView={initView}
      intent={intent}
      onClose={hideModal}
      onInsert={handleImageInsert}
      selectedEditorImageNode={selectedImage}
    />
  );
};
